import { EMPTY, type ListFieldFormatting } from '@ardoq/api-types';
import { getAttributeFormattingValue } from './filterUtils';

export const isListFieldIncluded = (
  fieldValue: string | undefined,
  formatting: ListFieldFormatting
): boolean => {
  const { isDisabled: isEmptyDisabled } = formatting[EMPTY];
  const listItem = fieldValue ? formatting[fieldValue] : undefined;
  if (listItem) {
    return !listItem.isDisabled;
  }
  return !isEmptyDisabled;
};

export const resolveListFieldColor = (
  fieldValue: string | undefined,
  formatting: ListFieldFormatting
): string | undefined => {
  const { isDisabled: isEmptyDisabled, color: emptyColor } = formatting[EMPTY];
  if (!fieldValue) {
    return isEmptyDisabled ? undefined : emptyColor;
  }
  const listItem = formatting[fieldValue];
  if (!listItem) {
    return isEmptyDisabled ? undefined : emptyColor;
  }
  const { color, isDisabled } = listItem;
  return isDisabled ? undefined : color;
};

export const getListFieldFormatting = (
  isFormattingFilter: boolean,
  filterValue: unknown,
  filterType: string | undefined
): ListFieldFormatting | null =>
  getAttributeFormattingValue<ListFieldFormatting>(
    isFormattingFilter,
    filterValue,
    filterType,
    (value): value is ListFieldFormatting =>
      Object.prototype.hasOwnProperty.call(value, EMPTY)
  );
